export const getRandomBoolean = () => {
  return Math.random() < 0.5;
};
